import { useMessageContext } from 'stream-chat-react';

import { useChatClient } from '@bizzabo/chat-core';
import { useCurrentUser } from '@bizzabo/entities';

import { extractChatPartner } from '../../../utils/helpers';
import MissedCallMessage from '../MissedCallMessage';
import { getMissedCallObj, isHideMessage } from './helpers';
import { MissedCallMetadataContent, AttendeeType } from './types';
import { useMessages } from '../../../contexts/MessagesContext';
import { ExtendedGetStreamMessage } from '../UIMessage/types';

const MissedCallMessageWrapper: React.FC = () => {
    const { client, channel } = useChatClient();
    const { message } = useMessageContext();
    const { eventId } = useMessages();
    const { data: currentUser, isLoading } = useCurrentUser(eventId);

    if (isLoading) {
        return null;
    }

    const messageMetadata = (message as ExtendedGetStreamMessage).metadata;
    const messageType = messageMetadata.type;
    const attendeeType =
        (messageMetadata as MissedCallMetadataContent).data?.caller === currentUser.id
            ? AttendeeType.HOST
            : AttendeeType.GUEST;

    if (isHideMessage(messageType, attendeeType)) {
        return null;
    }

    const chatPartner = extractChatPartner(channel, client);
    const messageObj = getMissedCallObj(chatPartner.firstName as string);
    const { title, text, icon } = messageObj[messageType][attendeeType];

    return (
        <MissedCallMessage title={title} text={text} icon={icon} startTime={message.created_at} />
    );
};

export default MissedCallMessageWrapper;
